import React, { useCallback, useEffect } from 'react'
import mapboxgl from 'mapbox-gl/dist/mapbox-gl-csp'
// eslint-disable-next-line import/no-webpack-loader-syntax
import { circle } from '@turf/turf'

import { getKpiColorByNetworkIndicator } from '../kpiUtils'
import { PopupBaseStation, PopupKpi } from '../../common/popup'

const eNBFromCid = cid => {
    if (cid) {
        const eNBHex = cid.toString(16).substring(0, 5)
        const eNB = parseInt(eNBHex, 16)
        return eNB
    }
}

function MapView(props) {
    const {
        baseStations,
        deviceList,
        endDate,
        map,
        mapContainer,
        rangeKpi,
        showConnections,
        state,
        startDate,
        getMapBounds,
        fetchBaseStations,
        fetchKpis,
        networkIndicator,
        setBaseStations,
        setMap,
        setState,
        loadNetwork,
        initParam
    } = props
    let loadingKpi = null
    let timeOutMove = null

    useEffect(() => {
        let lngLat = {}
        if (loadNetwork && initParam) {
            lngLat = {lng: initParam.lng, lat: initParam.lat}
        } else {
            lngLat = {lng: state.lng, lat: state.lat}
        }
        
        const map = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/dark-v9',
            center: [lngLat.lng, lngLat.lat],
            zoom: state.zoom,
        })

        map.on('load', async () => {
            setMap(map)
        })

        console.log('loadNetwork: ', loadNetwork)
        console.log('initParam: ', initParam)

        if (loadNetwork && initParam) {
            //const today = new Date()
            //const stDa = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0)
            //const enDa = today;
            const lngLat = {lng: initParam.lng, lat: initParam.lat}

            setState({ ...state, lng: initParam.lng, lat: initParam.lat })
            console.log('state: ', state)


            // delete old kpis to render new kpis
            /*
            deleteMarkerBaseStation()
            if (map.getSource('line')) {
                map.removeLayer('line-kpi')
                map.removeSource('line')
                map.removeLayer('kpi-circle')
                map.removeSource('kpi')
            }
            */
            
            renderKpis(
                initParam.lng,
                initParam.lat,
                undefined,
                4,
                initParam.startDate,
                initParam.endDate,
                undefined,
                map
            ).then(value => {
                renderCircle(lngLat, map)  
            })
            //
        }

        return () => map.remove()
    }, [])

    useEffect(() => {
        if (baseStations) {
            deleteMarkerBaseStation()
            // fetch base stations
            renderBaseStations(baseStations, map)
        }
    }, [baseStations])

    useEffect(() => {
        if (map) {
            if (showConnections) {
                renderConnections()
            } else {
                deleteConnections()
            }
        }
    }, [showConnections])

    useEffect(() => {
        if (map) {
            updateKpis(networkIndicator)
        }
    }, [networkIndicator])

    useEffect(() => {
        
    }, [loadNetwork])
    
    const onClickMap = (e, bs) => {
        console.log('e: ', e)
        console.log('bs: ', bs)
        
        if (!e.originalEvent.defaultPrevented && !loadingKpi) {
            // render blue circle
            renderCircle(e.lngLat, map)

            // delete old kpis to render new kpis
            deleteMarkerBaseStation()
            if (map.getSource('line')) {
                map.removeLayer('line-kpi')
                map.removeSource('line')
                map.removeLayer('kpi-circle')
                map.removeSource('kpi')
            }

            // render new kpis
            renderKpis(
                e.lngLat.lng,
                e.lngLat.lat,
                bs,
                rangeKpi,
                startDate,
                endDate,
                deviceList,
                map,
            )
        }
    }

    const callbackOnClick = useCallback(onClickMap, [
        showConnections,
        networkIndicator,
        deviceList,
        map,
    ])

    useEffect(() => {
        let refCallback = null
        if (map) {
            // OCTO-5
            refCallback = e => callbackOnClick(e)
            map.on('click', refCallback)
            
            map.on('move', () => {
                setState({
                    ...state,
                    lng: map.getCenter().lng.toFixed(4),
                    lat: map.getCenter().lat.toFixed(4),
                    zoom: map.getZoom().toFixed(2),
                })
            })

            // fetch base stations when map was set up
            /*
            const bounds = getMapBounds(map)
            fetchBaseStations(bounds).then(bs => {
                // send baseStations like params to set new base stations
                refCallback = e => callbackOnClick(e, bs)
                map.on('click', refCallback)

                setBaseStations(bs)

                map.on('move', () => {
                    setState({
                        ...state,
                        lng: map.getCenter().lng.toFixed(4),
                        lat: map.getCenter().lat.toFixed(4),
                        zoom: map.getZoom().toFixed(2),
                    })
                })

                map.on('moveend', async () => {
                    // clean delay
                    clearTimeout(timeOutMove)

                    // delay to fetch base stations
                    timeOutMove = setTimeout(async function () {
                        const bounds = getMapBounds(map)
                        const newBaseStations = await fetchBaseStations(bounds)
                        setBaseStations(newBaseStations)
                    }, 1500) // 1.5 seconds
                })
            })
            */
            return () => map.off('click', refCallback)
        }
    }, [map, callbackOnClick])

    const renderBaseStations = async (bs, map) => {
        bs.forEach(baseStation => {
            // create a DOM element for the marker
            renderMarkerBaseStation(baseStation, map)
        })
    }

    const renderKpis = async (
        lng,
        lat,
        newBaseStations,
        radius,
        startDate = '',
        endDate = '',
        deviceList = '',
        map,
    ) => {
        console.log('lng: ', lng)
        console.log('lat: ', lat)
        console.log('newBaseStations: ', newBaseStations)
        console.log('radius: ', radius)
        console.log('startDate: ', startDate)
        console.log('endDate: ', endDate)
        console.log('deviceList: ', deviceList)
        console.log('map: ', map)
        
        // delete loading image when you click before loading finished
        if (loadingKpi) {
            loadingKpi.remove()
            loadingKpi = null
        }
        showLoadingKpi(lng, lat, map)

        try {
            // new markers array
            let newMarkersKpi = []
            let newConnectionsKpi = []

            const kpis = await fetchKpis(lng, lat, radius, startDate, endDate, deviceList)
            // OCTO-5
            const newBaseStations = await fetchBaseStations(lng, lat, radius)
            setBaseStations(newBaseStations)
            hideLoadingKpi(map)

            // render new kpi markers
            kpis.forEach(kpi => {
                if (kpi.connectivity && kpi.location) {
                    const markerKpi = {
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: kpi.location.coordinates,
                        },
                        properties: {
                            connectivity: kpi.connectivity,
                            color: getKpiColorByNetworkIndicator(
                                networkIndicator,
                                kpi.connectivity.signal,
                            ),
                            description: PopupKpi(kpi),
                        },
                    }

                    //renderMarkerKpi(kpi, map)
                    newMarkersKpi.push(markerKpi)

                    // render connection lines between kpi and base station
                    const baseStationKpiCoordinates = newBaseStations.find(bs => {
                        if (bs.cid && Number(bs.cid) === Number(kpi.connectivity.cell.cid)) {
                            return true
                        } else if (bs.eNB) {
                            const kpiENB = eNBFromCid(kpi.connectivity.cell.cid)
                            return bs.eNB === kpiENB
                        }
                    })

                    let connectionKpi = null
                    if (!!baseStationKpiCoordinates) {
                        connectionKpi = {
                            type: 'Feature',
                            geometry: {
                                type: 'LineString',
                                coordinates: [
                                    kpi.location.coordinates,
                                    baseStationKpiCoordinates.location.coordinates,
                                ],
                            },
                        }
                        newConnectionsKpi.push(connectionKpi)
                    }
                }
            })

            //create Map source of kpis
            map.addSource('kpi', {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: newMarkersKpi,
                },
            })

            // create layer to source of lines connection
            map.addLayer({
                id: 'kpi-circle',
                type: 'circle',
                source: `kpi`,
                paint: {
                    'circle-stroke-color': ['get', 'color'],
                    'circle-color': ['get', 'color'],
                    'circle-stroke-width': 1,
                },
            })

            // create Map source of lines (connections)
            map.addSource('line', {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: newConnectionsKpi,
                },
            })

            // create layer to source of lines connection
            // connections are created by default, but it will show depends of showConnectionsRef
            // the ref is to keep the state of switch (Show connections) up to date
            map.addLayer({
                id: 'line-kpi',
                type: 'line',
                source: `line`,
                layout: {
                    'line-cap': 'round',
                    'line-join': 'round',
                    visibility: showConnections ? 'visible' : 'none',
                },
                paint: {
                    'line-color': 'red',
                    'line-width': 2,
                    'line-opacity': 0.9,
                },
            })

            // Create a popup
            let popup = new mapboxgl.Popup({
                closeButton: false,
                closeOnClick: false,
            })

            // Show popup when the mouse is over the kpi layer.
            map.on('mouseenter', 'kpi-circle', function (e) {
                map.getCanvas().style.cursor = 'pointer'

                var coordinates = e.features[0].geometry.coordinates.slice()
                var description = e.features[0].properties.description

                // Ensure that if the map is zoomed out such that multiple
                // copies of the feature are visible, the popup appears
                // over the copy being pointed to.
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
                }

                popup.setLngLat(coordinates).setHTML(description).addTo(map)
            })

            map.on('mouseleave', 'kpi-circle', function () {
                map.getCanvas().style.cursor = ''
                popup.remove()
            })
        } catch (error) {
            console.log(error)
        }
    }

    /**
     * Update kpi style (circle fill color)
     * depends of network indicator value
     * @param {String} newNetworkIndicator network indicator value
     */
    const updateKpis = newNetworkIndicator => {
        const kpis = map.getSource('kpi')
        if (!!kpis) {
            const featuresKpis = kpis._data.features
            let newFeatures = []

            // net new color of each kpi circle
            featuresKpis.forEach(kpi => {
                const newFeature = {
                    geometry: kpi.geometry,
                    type: kpi.type,
                    properties: {
                        ...kpi.properties,
                        color: getKpiColorByNetworkIndicator(
                            newNetworkIndicator,
                            kpi.properties.connectivity.signal,
                        ),
                    },
                }

                newFeatures.push(newFeature)
            })
            kpis.setData({
                type: 'FeatureCollection',
                features: newFeatures,
            })
        }
    }

    const renderCircle = (location, map) => {
        console.log('location: ', location)
        const { lng, lat } = location

        deleteCircle(map)

        const options = {
            steps: 64,
            units: 'kilometers',
            properties: { foo: 'bar' },
        }
        const newCircle = circle([lng, lat], rangeKpi, options)

        // Add a data source containing GeoJSON data.
        map.addSource('circleClicked', {
            type: 'geojson',
            data: newCircle,
        })

        // Add a new layer to visualize the polygon.
        map.addLayer({
            id: 'circleFill',
            type: 'fill',
            source: 'circleClicked', // reference the data source
            layout: {},
            paint: {
                'fill-color': 'transparent', // blue color fill
                'fill-opacity': 0.5,
            },
        })

        // Add a black outline around the polygon.
        map.addLayer({
            id: 'circleOutline',
            type: 'line',
            source: 'circleClicked',
            layout: {},
            paint: {
                'line-color': 'yellow',
                'line-width': 3,
            },
        })
    }

    const deleteCircle = map => {
        // delete repeated layers and source
        if (map.getSource('circleClicked')) {
            map.removeLayer('circleFill')
            map.removeLayer('circleOutline')
            map.removeSource('circleClicked')
        }
    }

    const renderMarkerBaseStation = (baseStation, map) => {
        let el = document.createElement('div')
        el.className = 'marker-basestation'
        el.style.backgroundImage =
            'url(https://iconsplace.com/wp-content/uploads/_icons/ffffff/256/png/radio-tower-icon-18-256.png)'
        el.style.width = '25px'
        el.style.height = '25px'
        el.style.backgroundSize = '100%'
        el.style.opacity = '0.4'

        el.onclick = function (e) {
            e.preventDefault()
        }

        // create the popup
        var popup = new mapboxgl.Popup({ offset: 25, className: 'my-class' })
            .setHTML(PopupBaseStation(baseStation))
            .setMaxWidth('300px')

        const marker = new mapboxgl.Marker({ element: el })
            .setLngLat(baseStation.location.coordinates)
            .setPopup(popup) // sets a popup on this marker
            .addTo(map)

        return marker
    }

    const deleteMarkerBaseStation = () => {
        // delete old markers
        const oldMarkers = document.getElementsByClassName('marker-basestation')
        while (oldMarkers.length > 0) {
            oldMarkers[0].remove()
        }
    }

    const renderConnections = () => {
        // show connections lines
        if (map !== undefined && map.getSource('line')) {
            map.setLayoutProperty('line-kpi', 'visibility', 'visible')
        }
    }

    const deleteConnections = () => {
        // hide connections lines
        if (map !== undefined && map.getSource('line')) {
            map.setLayoutProperty('line-kpi', 'visibility', 'none')
        }
    }

    const showLoadingKpi = (lng, lat, map) => {
        // create a DOM element for the marker KPI
        let loadingElement = document.createElement('div')
        loadingElement.className = 'marker-loading'
        loadingElement.style.backgroundImage = "url('ball-triangle.svg')"
        loadingElement.style.width = '35px'
        loadingElement.style.height = '35px'
        loadingElement.style.backgroundSize = '100%'
        loadingKpi = new mapboxgl.Marker({ element: loadingElement })
            .setLngLat([lng, lat])
            .addTo(map)
    }

    const hideLoadingKpi = map => {
        loadingKpi.remove()
        loadingKpi = null
    }

    return <div className="map-container" ref={mapContainer} />
}

export default MapView
